import { createFileRoute } from '@tanstack/react-router';
import PrivacyPage from '../views/privacy';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});
